module.exports = __webpack_public_path__ + "static/media/stuff crust.944d48aa.png";